module.exports = __webpack_public_path__ + "static/media/clocards-ping.db453bfc.png";